import { ReactElement } from 'react'
import UserList from '../../components/Users'
import Layout from '../../components/layout'

const UsersPage = (): ReactElement => {
  return (
    <Layout>
      <UserList />
    </Layout>
  )
}

export default UsersPage
